import { IXepTKBLopTCActionTypes } from "../../action-types/tkb/IXepTKBLopTCActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IXepTKBLopTCReducer } from "../../reducer-model/tkb/IXepTKBLopTCReducer";
const iniState: IXepTKBLopTCReducer = {
    status: eReducerStatusBase.is_not_initialization,
    suKiens: [],
    lopTinChis: [],
    filter: {
        hoc_ky: 0,
        id_chuyen_nganh: 0,
        id_he: 0,
        khoa_hoc: 0,
        ky_dang_ky: 0,
        nam_hoc: "",
        stu_nhomlop_ids: [],
        id_nganh: 0,
        pl_giaidoan_id: 0,
        id_bm: 0,
        id_mon: 0
    },
    lopFilter: {
        isShowLopChung: true,
        isShowLopKeHoach: true
    }

}
export const xepTKBLopTCReducer = (state: IXepTKBLopTCReducer = iniState, action: IXepTKBLopTCActionTypes): IXepTKBLopTCReducer => {
    switch (action.type) {
        case "XEP_TKB_LOP_TC_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload
            }
        case "XEP_TKB_LOP_TC_LOAD_ALL_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "XEP_TKB_LOP_TC_LOAD_ALL_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                suKiens: action.payload.suKiens,
                lopTinChis: action.payload.lopTinChis
            }
        case "XEP_TKB_LOP_TC_LOAD_ALL_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "XEP_TKB_LOP_TC_CHANGE_LOPTINCHI_FILTER":
            return {
                ...state,
                lopFilter: action.payload
            }
        default:
            return {
                ...state
            };
    }
}